import { HistoryOrder, Order } from '@lib/types';

export function fromHistoryOrderToOrder(order: HistoryOrder): Order {
  return {
    ...order,
    orderMessage: {
      ...order.orderMessage,
      data: {
        ...order.orderMessage.data,
        categories: order.orderMessage.data.categories.map((cat) => ({
          ...cat,
          items: cat.items.map((item) => ({
            ...item,
            item: {
              ...item.item,
              topping: item.item.topping.map((top) => ({
                category: {
                  uuid: top.categoryUUID,
                  arName: top.categoryArName,
                  enName: top.categoryEnName,
                },
                extraItems: top.extraItems.map((extra) => ({
                  orderItemExtraUUID: extra.orderItemExtraUUID,
                  price: extra.price,
                  size: {
                    enName: extra.sizeEnName,
                    arName: extra.sizeArName,
                    uuid: extra.sizeUUID,
                  },
                  item: {
                    enName: extra.itemEnName,
                    arName: extra.itemArName,
                    uuid: extra.itemUUID,
                  }
                })),
              })),
            },
          })),
        })),
      },
      trace: {
        created: {
          by: order.orderMessage.trace.created.by,
          at: new Date(order.orderMessage.trace.created.at),
        },
        updated: {
          by: order.orderMessage.trace.updated.by,
          at: new Date(order.orderMessage.trace.updated.at),
        },
      },
    },
    orderStateTrace: {
      ...order.orderStateTrace,
    },
  };
}
